import { ChangeDetectorRef, Component, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild, } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from '@spartacus/core';
import { SearchBoxConfig, } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as __ from 'lodash';
import { combineLatest, filter, Subscription } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import * as config from '../../../../shared/config/app.config';
import { ContractConditions, ContractControls } from '../../../model/contract-conditions.model';
import { PriceChannel } from '../../../model/price-channel.model';
import { CustomProduct } from '../../../model/product.model';
import { ProductUtils } from '../../../utils/productUtils';

const RESERVE_NOW_TRANS_KEY = 'addToCartItems.reserveNow';
const ADD_TO_CART_TRANS_KEY = 'addToCartItems.addCart';

@Component({
  selector: 'app-quick-order',
  templateUrl: './quick-order.component.html',
  styleUrls: ['./quick-order.component.scss'],
  standalone: false
})
export class QuickOrderComponent implements OnInit, OnDestroy {
  private readonly user = inject(UserAccountFacade);
  private readonly translationService = inject(TranslationService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly baseService = inject(BaseService);

  protected readonly ProductUtils = ProductUtils;
  protected readonly PriceChannel = PriceChannel;
  @Output() selectedProductEvent = new EventEmitter<any>();
  quickOrderDetail = false;
  clearSearch = false;
  productInfo: CustomProduct;
  buttonName: string;
  itemAddedQuantity: any;
  userDetails: any;
  QUICKORDER_SEARCH_BOX_CONFIG: SearchBoxConfig = {
    minCharactersBeforeRequest: 3,
    displayProducts: true,
    displaySuggestions: false,
    displayProductImages: true,
  };
  clearSearchValue = false;
  userDataSub: Subscription;
  allCartsSub: Subscription;

  updatedCartDetailsSub: Subscription;
  showContract: boolean;
  multipleContract: boolean;
  productConditions: ContractConditions[];
  contractFromCartApi: string;
  showContractList: boolean;
  contractSelected: ContractConditions;
  contractSelectedId: string;
  enableBtn: boolean;
  selectedChannel: PriceChannel;
  selectedProduct: any;
  priceToShow: number;
  showPriceGroup: boolean = false;
  priceGroupToShow: any;
  priceToShowGroupId: string;
  cartId: string;
  carts: any;
  hasMatchingContract: boolean;
  successMsg: boolean = false;
  updateErrorSub: Subscription;
  conditionsForCartonsLogicMeet = false;
  @ViewChild('p2') public successPopover: NgbPopover;
  private successMsgTimeout = 2500;
  private addCartTranslation = '';
  private reserveNowTranslation: string;

  ngOnInit(): void {
    this.userDataSub = combineLatest([
      this.user.get()
        .pipe(
          filter(Boolean),
        ),
      this.translationService.translate(ADD_TO_CART_TRANS_KEY),
      this.translationService.translate(RESERVE_NOW_TRANS_KEY),
    ]).subscribe(([user, addCartTrans, reserveNowTrans]) => {
      this.userDetails = user;
      this.addCartTranslation = addCartTrans;
      this.reserveNowTranslation = reserveNowTrans;
      this.selectedChannel = this.userDetails?.channel;
      this.buttonName = this.productInfo?.flu ? this.reserveNowTranslation : this.addCartTranslation;
    });
  }

  getCarts(userId: string, product: CustomProduct): void {
    this.allCartsSub = this.baseService
      .get(config.USER_ACCOUNT + userId + '/carts')
      .pipe(
        filter(Boolean),
      )
      .subscribe((cart) => {
        this.carts = __.remove(cart?.carts, function(n) {
          return !n.savedBy;
        });
        const cond = product?.conditions;

        if (this.carts?.length === 0 || this.carts[0]?.childCarts?.length === 0) {
          // No cart let's create a method
          this.selectedChannel === PriceChannel.PUBLIC && cond ? this.noCart(product) : this.noContract();
        } else {
          this.contractFromCartApi = this.carts[0]?.childCarts[0]?.contractId; //Selected contract
          if (__.some(cond, ['contractId', this.contractFromCartApi]) === true) {
            // check if product list of contracts has one of the selected contract
            this.hasMatchingContract = true;
            this.hasCartAndMatchingContract(product);
          } else {
            if (this.selectedChannel === PriceChannel.PUBLIC) {
              this.hasMatchingContract = false;
              this.hasCartNoMatchingContract();
            }
          }
        }
        this.cdr.detectChanges();
      });
  }

  noContract(): void {
    this.showContract = true;
    this.showContractList = false;
    this.clearContract();
  }

  noCart(product: CustomProduct): void {
    this.clearContract();

    if (!product?.conditions || !product?.conditions?.length) {
      return;
    }

    this.multipleContract = true;
    this.showContract = true;
    this.productConditions = product?.conditions;
    if (product?.conditions?.length > 1) {
      this.showContractList = true;
      this.priceToShow = null;
    } else {
      this.showContractList = false;
      if (
        product?.conditions &&
        product.conditions[0]?.priceGroups?.length > 1
      ) {
        // multiple price group
        this.showContract = true;
        this.showPriceGroup = true;
        this.priceGroupToShow = product.conditions[0]?.priceGroups;
        this.contractSelected = product?.conditions[0];
        this.contractSelectedId = product?.conditions[0]?.contractId;
        this.enableBtn = false;
      } else {
        // one price group
        this.showPriceGroup = false;
        this.enableBtn = true;
        this.showContract = true;
        if (product && product?.conditions) {
          this.priceToShow = product?.conditions[0]?.priceGroups[0]?.priceData?.value;
          this.priceToShowGroupId = product?.conditions[0]?.priceGroups[0]?.groupId;
          this.contractSelectedId = product?.conditions[0]?.contractId;
          this.contractSelected = product?.conditions[0];
        }
      }
    }
  }

  hasCartAndMatchingContract(product: CustomProduct): void {
    this.clearContract();
    this.showContract = true;
    const cond = product?.conditions;

    const matchingContract = cond.find(item => item.contractId === this.contractFromCartApi);

    this.contractSelected = matchingContract;
    this.priceGroupToShow = matchingContract?.priceGroups;

    if (this.priceGroupToShow.length > 1) {
      this.enableBtn = false;
      this.showPriceGroup = true;
      this.contractSelectedId = matchingContract?.contractId;
    } else {
      this.enableBtn = true;
      this.priceToShow = matchingContract?.priceGroups[0]?.priceData?.value;
      this.priceToShowGroupId = matchingContract?.priceGroups[0]?.groupId;
      this.contractSelectedId = matchingContract?.contractId;
    }
  }

  hasCartNoMatchingContract(): void {
    this.enableBtn = false;
    this.showContract = true;
    this.clearContract();
  }

  performQuantityComputation(operator: number | null): void {
    ProductUtils.alterQuantity(
      operator,
      this.productInfo.code + 'q',
      this.productInfo.quantityPerUnit,
      this.selectedChannel,
      this.conditionsForCartonsLogicMeet ? this.productInfo.numberOfUnitsPerCarton : 0
    );
  }

  onProductSelected(product: CustomProduct): void {
    this.selectedProduct = product;
    if (product?.code) {
      this.productInfo = {...product};
      this.quickOrderDetail = true;
    } else {
      this.quickOrderDetail = false;
    }

    this.conditionsForCartonsLogicMeet = ProductUtils.channelPrivateAndNumberUnitsPerCartonMoreThanOne(
      this.productInfo.numberOfUnitsPerCarton ? this.productInfo.numberOfUnitsPerCarton : 0,
      this.selectedChannel
    );

    this.getCarts(this.userDetails?.uid, product);
  }

  clearContract(): void {
    this.contractSelected = null;
    this.contractSelectedId = null;
    this.showPriceGroup = false;
    this.priceGroupToShow = null;
    this.priceToShow = null;
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.userDataSub?.unsubscribe();
    this.updatedCartDetailsSub?.unsubscribe();
    this.allCartsSub?.unsubscribe();
  }

  checkIfUnavailableToOrder(): boolean {
    return !this.checkIfProductIsLimited() && !this.productPriceIsValid() && !this.conditionsAndPriceDataValueIsValid();
  }

  displayLocalPriceAsLocalCurrency(): boolean {
    return this.productPriceIsValid() ||
      (this.selectedChannel === PriceChannel.PUBLIC && (!this.showContract || (!this.contractSelected && !this.productInfo.conditions)));
  }

  private checkIfProductIsLimited(): boolean {
    return this.productInfo?.stockAvailableStatus === 'LIMITED' && this.productInfo?.allowLimitedStockProducts !== true;
  }

  private conditionsAndPriceDataValueIsValid(): boolean {
    return this.productInfo.conditions &&
      !!this.productInfo.conditions.length &&
      !!this.productInfo.conditions[0]?.priceGroups[0]?.priceData.value &&
      this.selectedChannel === PriceChannel.PUBLIC;
  }

  private productPriceIsValid(): boolean {
    return this.productInfo.price && !!this.productInfo.price.value && this.selectedChannel === PriceChannel.PRIVATE;
  }

  onSelectedContract(controls: ContractControls): void {
    this.enableBtn = controls.enableBtn;
    this.priceToShow = controls.priceToShow;
    this.contractSelectedId = controls.contractSelected.contractId;
    this.priceToShowGroupId = controls.priceToShowGroupId;
    this.priceGroupToShow = controls.priceGroupToShow;
    this.contractSelected = controls.contractSelected;
    this.cdr.detectChanges();
  }

  onSelectPriceGroup(controls: ContractControls) {
    this.enableBtn = controls.enableBtn;
    this.priceToShow = controls.priceToShow;
    this.priceToShowGroupId = controls.priceToShowGroupId;
    this.cdr.detectChanges();
  }
}
